import { Box, Chip, IconButton, Paper, Typography } from '@mui/material';
import { toast } from 'material-react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import { WishlistLine } from '../../interfaces/Wishlist/WishlistLine';
import { sharedColors } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';
import { removeProductFromWishlist } from '../../api/Wishlist';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type WishlistCardProps = {
  line: WishlistLine;
  onRemove: () => void;
};

export const WishlistCard = ({ line, onRemove }: WishlistCardProps) => {
  const t = useLocalizedText();

  const { primary, secondary } = useThemeColor();

  const handleDelete = () => {
    removeProductFromWishlist(line.productID)
      .then(() => {
        toast.success(t('wishlist.product_deleted'));
        onRemove();
      })
      .catch((err) => toast.error(err.message));
  };

  return (
    <Link to={`/urun/${line.product.slug}`} style={{ textDecoration: 'none' }}>
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          alignItems: 'center',
          width: '100%',
          p: 2.5,
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        <IconButton
          size='small'
          onClick={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();

            handleDelete();
          }}
          sx={{
            backgroundColor: primary,
            color: secondary,
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          component='img'
          src={line.product.baseImage.path}
          height={160}
          width='auto'
        />

        <Typography sx={{ fontWeight: 600, textAlign: 'center' }}>
          {line.product.name}
        </Typography>

        {line.product.qty ? (
          <Chip
            color='success'
            label={t('wishlist.in_stock')}
            sx={{ fontWeight: 600 }}
          />
        ) : (
          <Chip
            color='error'
            label={t('wishlist.out_of_stock')}
            sx={{ fontWeight: 600 }}
          />
        )}

        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5 }}>
          {!!line.product.specialPrice && (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '15px',
                color: sharedColors.gray5,
                textDecoration: 'line-through',
              }}
            >
              {line.product.price.formatted}
            </Typography>
          )}

          <Typography
            sx={{ fontWeight: 600, fontSize: '15px', color: primary }}
          >
            {line.product.specialPrice
              ? line.product.specialPrice.formatted
              : line.product.price.formatted}
          </Typography>
        </Box>
      </Paper>
    </Link>
  );
};
